import { metricKeys } from '@pulse/metrics';
import { get, isEmpty, orderBy } from 'lodash';
import { DATASET } from '@utils/constants';
import { IMPROVEMENT_OPPORTUNITY_METRICS } from '@src/utils/kpi';
import {
  adContentMap,
  AD_CONTENT_DIMENSION,
  AD_CONTENT_KEYS,
  AD_WITH_PREROLL,
  AD_WITHOUT_PREROLL,
} from '@utils/adContent/mappings';
import { getMetricDisplayName, getMetricOvbDisplayName } from '@src/utils/metrics';

const baseQuery = {
  type: 'group-by',
  dataset: DATASET,
  metrics: [],
  interval: '2018-12-19T22:35:18.907Z/2018-12-20T22:35:18.907Z',
  granularity: 'ALL',
  filter: [],
  limit: 3, // true, false or unknown
  groupBy: [AD_CONTENT_DIMENSION],
  orderBy: 'desc',
  sortBy: [{ metric: metricKeys.Attempts, order: 'desc' }],
  options: {
    withTotals: true,
    withOverviewThresholds: true,
    kpiConfig: {},
  },
};

const adBaseQuery = {
  type: 'timeseries',
  dataset: DATASET,
  metrics: [],
  interval: '2021-08-01T00:00:00Z/2021-08-05T00:00:00Z',
  granularity: 'ALL',
  filter: [],
  options: {
    withTotals: false,
    withOverviewThresholds: true,
    kpiConfig: {},
  },
};

const createQuery = ({ metrics, interval, filter, kpiConfig }) => {
  const query = {
    ...baseQuery,
    metrics,
    interval,
    filter,
  };
  query.options.kpiConfig = kpiConfig;
  query.sortBy[0].metric = metrics[0];

  return {
    queries: [query],
  };
};

const createAdQuery = ({ metrics, interval, filter, kpiConfig }) => {
  const query = {
    ...adBaseQuery,
    metrics,
    interval,
    filter,
  };
  query.options.kpiConfig = kpiConfig;

  return {
    queries: [query],
  };
};

const formatAdStartupContentData = (response) => {
  const data: any = get(response, '0.data.0.results', []);
  const finalData: any = {
    preRoll: [],
    ads: [],
  };
  const dataArray: any = [];
  // Find contnet keys match & extract them with the response
  AD_CONTENT_KEYS.forEach((key: any) => {
    const z = Object.keys(data)
      .filter((k: any) => {
        return k.indexOf(key) == 0;
      })
      .reduce((newData: any, k: any): any => {
        const objKey = k.replace(key, '');
        if (objKey && objKey.trim().length) {
          newData[objKey] = data[k];
        } else {
          newData.overAll = data[k];
        }
        newData.metricName = getMetricDisplayName({ metricKey: key });
        newData.metric = key;
        newData[key] = data[k];
        return newData;
      }, {});
    dataArray.push(z);
  });
  if (dataArray && dataArray.length) {
    dataArray.forEach((item) => {
      if (item && (AD_WITH_PREROLL in item || AD_WITHOUT_PREROLL in item)) {
        finalData.preRoll.push(item);
      } else {
        finalData.ads.push(item);
      }
    });
  }
  return finalData;
};

const formatAdContentData = (response) => {
  try {
    if (response) {
      const results = get(response, '0.data.0.results', []);
      const totals = get(response, '0.totals.0.results', {});

      const parsed: any = {};
      results.forEach((row) => {
        const key = row[AD_CONTENT_DIMENSION];
        if (key in adContentMap) {
          parsed[adContentMap[key]] = row;
        }
      });

      if (!isEmpty(parsed)) {
        const rows = IMPROVEMENT_OPPORTUNITY_METRICS.map((metric) => ({
          withAds: get(parsed, ['withAds', metric], null),
          withoutAds: get(parsed, ['withoutAds', metric], null),
          overall: get(totals, [metric], null),
          metricName: getMetricOvbDisplayName({ metricKey: metric }),
          metric,
        }));
        return orderBy(rows, ['overall'], ['desc']);
      }
    }
  } catch (err) {
    // ignore
  }
  return null;
};

export { createQuery, createAdQuery, formatAdContentData, formatAdStartupContentData };
